import urls from '../constants/urls'

import { paginationParams } from '../utils/pagination'

export const HOSPITALS_LOAD_FAILED = 'workspaces/HOSPITALS_LOAD_FAILED'
export const HOSPITALS_LOAD_SUCCESS = 'workspaces/HOSPITALS_LOAD_SUCCESS'
export const LOADING_HOSPITALS = 'workspaces/LOADING_HOSPITALS'

const initialState = {
  initialLoad: true,

  workspaces: [],

  // Permissions

  failedLoading:  false,
  failedCreating: false,

  isLoading:  false,
  isCreating: false,

  page:           1,
  preSearchTotal: 0,
  total:          0
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_HOSPITALS:
      return {
        ...state,
        failedLoading: false,
        isLoading:     true
      }

    case HOSPITALS_LOAD_SUCCESS:
      let payloadData = action.payload.data
      return {
        ...state,
        workspaces:                 payloadData.data,
        ...paginationParams(action.payload.headers['link'], action.payload.headers['x-total']),
        searchTerm:                 action.meta.previousAction.searchTerm,
        initialLoad:                false,
        isLoading:                  false
      }

    case HOSPITALS_LOAD_FAILED:
      return {
        ...state,
        failedLoading: true,
        isLoading:     false
      }

    default:
      return state
  }
}

export const loadWorkspaces = (page, searchTerm = '') => (dispatch) => {
  return dispatch({
    types:   [LOADING_HOSPITALS, HOSPITALS_LOAD_SUCCESS, HOSPITALS_LOAD_FAILED],
    payload: {
      request: {
        url:    urls.admins.workspaces.index,
        params: { page: page, search_string: searchTerm },
      }
    },
    searchTerm: searchTerm
  })
}
